export const DATE_PARAM_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
